import type {NodeSchedule} from 'src/types/node-schedule';

import type {VoicebotState} from 'src/types/voicebot';
import type {Dispatch, ThunkAction} from 'src/reducers';
import * as reduxApiBff from 'src/utils/redux-api-bff';
import {parseVoicebot} from 'src/utils/voicebot';


export const UPDATE_VOICEBOT_INFO = 'voicebot/update';
export const UPDATE_NODE_SCHEDULE = 'voicebot/update-node-schedule';
export const RESET = 'voicebot/reset';

export const RESET_BOT_VARS = 'voicebot/resetBotVars';

type UpdateVoicebotInfoPayload = Partial<VoicebotState>;

type UpdateVoicebotInfoAction = {
  type: 'voicebot/update';
  payload: UpdateVoicebotInfoPayload;
};
type UpdateNodeScheduleAction = {
  type: typeof UPDATE_NODE_SCHEDULE;
  payload: Partial<NodeSchedule>;
};

type ResetStateAction = {
  type: 'voicebot/reset';
};

type ResetBotVarsStateAction = {
  type: 'voicebot/resetBotVars';
};

export type VoicebotAction =
  | UpdateVoicebotInfoAction
  | UpdateNodeScheduleAction
  | ResetStateAction
  | ResetBotVarsStateAction;

export const reset = (): ResetStateAction => ({type: RESET});

export const resetBotVars = (): ResetBotVarsStateAction => ({
  type: RESET_BOT_VARS,
});

export const updateVoicebotInfo = (
  payload: UpdateVoicebotInfoPayload,
): UpdateVoicebotInfoAction => ({
  type: UPDATE_VOICEBOT_INFO,
  payload,
});
export const updateNodeSchedule = (
  payload: Partial<NodeSchedule>,
): UpdateNodeScheduleAction => ({
  type: UPDATE_NODE_SCHEDULE,
  payload,
});

export const getVoicebotTaskNode: (node_id: string) => ThunkAction<unknown> =
  (node_id) => async (dispatch: Dispatch) => {
    const fetchedNodeResponse = await dispatch(
      reduxApiBff.get(`node/composite`, {
        node_id,
      }),
    );
    const parsedVoicebotNode = parseVoicebot(fetchedNodeResponse.body);
    return dispatch(updateVoicebotInfo(parsedVoicebotNode));
  };
